<template>
    <div class="line-form__body line-form__body--full block-wrap js-pay-container">
        <div class="line-form__check line-form__col line-form__col--agree-right">
            <h5 class="line-form__check-title">Оплата по лицевому счету</h5>
            <label class="cb-input">
                <input v-model="agree" class="cb-input__checkbox input req" type="checkbox" data-type="checkbox">
                <span class="cb-input__check"></span>
                <span class="cb-input__label"><a href="/Site/UserAgreement" target="_blank" class="link link--underline"><span class="link__text">С порядком и условиями оплаты, зачисления и возврата денежных средств согласен</span></a></span>
            </label>
            <!--<div class="line-form__check-message ex-small">
                При оплате услуг банковской картой взымается комиссия – 1% (один процент)
            </div>-->
        </div>
        <div class="line-form__payment-btns">
            <div class="line-form__double-btn-width">
                <div class="payment-drop js-cards-container">
                    <button type="button" class="button button--with-arrow button--th-second payment-drop__toggle js-cards-toggle" data-toggle="dropdown">
                        <img v-if="((PaymentMethod.substring(0,2)==='Сб') || (PaymentMethod.substring(0,2)==='Га'))" class="payment-drop__icon" v-bind:src="imageUrl(PaymentMethod)"
                             style="width:30px !important; height: 30px !important;">
                        <img v-else class="payment-drop__icon" v-bind:src="imageUrl(PaymentMethod)">
                        <span class="payment-drop__text">{{PaymentMethod}}</span>
                    </button>
                    <div class="payment-drop__drop">
                        <ul class="payment-drop__drop-inner">
                            <li class="payment-drop__item">
                                Оплатите картой любого банка
                            </li>
                            <li class="payment-drop__divider"></li>
                            <li class="payment-drop__item" @click="selectcard(-1,true)">
                                <div class="payment-drop__link js-cards-option">
                                    <img class="payment-drop__icon" src="/images/pay-types/gasprombank-icon.png"
                                         style="width:30px !important; height: 30px !important;" />
                                    <span class="payment-drop__text">Газпромбанк</span>
                                </div>
                            </li>
                            <li class="payment-drop__item" v-for="(option,index) in options" :value="option.CardId" @click="selectcard(index,true)">
                                <div class="payment-drop__link js-cards-option">
                                    <img class="payment-drop__icon" v-bind:src="option.image" style="width:35px !important;" />
                                    <span class="payment-drop__text">{{ option.MaskName }}</span>
                                    <span class="payment-drop__subtext">до <span class="status-error" v-bind:style="{color: option.color}">{{option.ExpDate}}</span></span>
                                </div>
                            </li>

                            <li v-if="account.isSber" class="payment-drop__divider"></li>
                            <li v-if="account.isSber" class="payment-drop__item" @click="selectcard(-1,false)">
                                <div class="payment-drop__link js-cards-option">
                                    <img class="payment-drop__icon" src="/images/pay-types/sberbank-icon.png" style="width:30px !important; height: 30px !important;" />
                                    <span class="payment-drop__text">Сбербанк</span>
                                </div>
                            </li>
                            <li v-if="account.isSber" class="payment-drop__item" v-for="(option,index) in optionsSber" :value="option.CardId" @click="selectcard(index,false)">
                                <div class="payment-drop__link js-cards-option">
                                    <img class="payment-drop__icon" v-bind:src="option.image" style="width:35px !important;" />
                                    <span class="payment-drop__text">{{ option.MaskName }}</span>
                                    <span class="payment-drop__subtext">до <span class="status-error" v-bind:style="{color: option.color}">{{option.ExpDate}}</span></span>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="amount-pay-container js-edit-payment-amount-container">
                <div v-if="isEditSum" class="line-form__amount-edit line-form__double-btn-width js-block-edit-payment-amount">
                    <input class="input js-edit-payment-amount-input" v-model="manSum" data-mask-max-8="" type="text" :placeholder="sumPay">
                    <button @click="isEditSum=false;manSum=''" class="text-edit-trigger text-edit-trigger--remove js-clear-payment-amount">
                        <i class="icon icon--close"></i>
                    </button>
                </div>
                <button v-else class="button button--th-main js-btn-pay line-form__double-btn-width js-button-payment-amount"
                        :class="(agree && (sumPay > 0) && (isSberPay != null)) ? '' : 'is-disable'"
                        v-on:click="pay">
                    Оплатить <span class="js-payment-amount-count-block">&nbsp;{{sumPay}}</span> ₽
                </button>
                <!-- редактирования суммы оплаты -->
                <button v-if="isEditSum" @click="recalcSum" class="text-edit-trigger text-edit-trigger--abs text-edit-trigger--remove js-check-edit-payment-amount"><i class="icon icon--check"></i></button>
                <button v-if="idxShowPay>=0 && !isEditSum" @click="isEditSum=true" class="text-edit-trigger text-edit-trigger--abs js-edit-payment-amount"><i class="icon icon--edit"></i></button>
            </div>

        </div>
    </div>



</template>

<script type="text/javascript">

    export default {
        name: 'account-pay',
        props: {
            account: Object,
            cards: Array,
            checkAgreement: Boolean,
            idxShowPay: Number
        },
        data: function () {
            return {
                sumPay: 0.0,
                manSum: '',
                paycard: '',
                options: [],
                optionsSber: [],
                merchCode: "FL",
                agree: false,
                PaymentMethod: "Способ оплаты",
                isSberPay: null,
                isEditSum: false
            }
        },
        computed: {
            phone: function () {
                if (gl_phone.length == 11 && gl_phone.substring(0, 1) === "7")
                    return "+7 (" + gl_phone.substring(1, 4) + ') '
                        + gl_phone.substring(4, 7) + '-'
                        + gl_phone.substring(7);
                return gl_phone;
            },
            email: function () {
                return gl_email;
            }
        },
        methods: {
            recalcSum: function () {
                this.isEditSum = false;
                this.$emit('UpdateManSum', this.manSum);
            },
            selectcard: function (index, isGpb) {
                this.isSberPay = !isGpb;
                if (index < 0) {
                    this.paycard = '';
                    this.PaymentMethod = (isGpb) ? "Газпромбанк" : "Сбербанк";
                }
                else {
                    this.paycard = (isGpb) ? this.options[index].CardId : this.optionsSber[index].CardId;
                    this.PaymentMethod = (isGpb) ? this.options[index].MaskName : this.optionsSber[index].MaskName;
                }
                return true;
            },
            addcard: function () {
                window.location = "/Profiles/AddCard/" + this.merchCode;
            },
            pay: function () {
                let order = {};
                if (this.paycard) { order.CardId = this.paycard; }
                order.BSPID = this.account.BspId;
                order.Email = gl_email;
                order.Phone = gl_phone;
                order.UserId = "";
                order.Items = [];
                order.SupplierId = this.account.SupplierId; // Для оплаты Сбер.
                for (var index in this.account.CalcData.Products) {
                    if (this.account.CalcData.Products[index].ToPayCheck || this.account.CalcData.Products[index].IsUserPay) {
                        let prod = {};
                        prod.Sum = this.account.CalcData.Products[index].ToPayProd;
                        if (prod.Sum > 0.0) {
                            prod.ContractId = this.account.CalcData.Products[index].ContractId;
                            prod.Item = this.account.CalcData.Products[index].Item;
                            prod.Saldo = this.account.CalcData.Products[index].SaldoEnd;
                            order.Items.push(prod);
                        }
                    }
                }
                if (order.Items.length == 0) return;
                this.agree = false;
                var self = this;
                axios.post('/Profiles/Pay/' + this.isSberPay, order)
                    .then(function (response) {
                        var data = response.data;
                        if (data.error) {
                            if (self.isSberPay) {
                                let err = JSON.parse(data.error);
                                console.log(err);
                                alert(err.info);
                                window.location = err.redirect;
                            }
                            else {
                                alert(data.error);
                            }
                        }
                        else
                            window.location = data.uri;
                    })
                    .catch(function (error) {
                        alert(error);
                        console.log(error)
                    });
                return true;
            },
            calc: function () {
                if (this.account.CalcData.CanPay) {

                    var sum = 0.0;
                    for (var index in this.account.CalcData.Products) {
                        if (this.account.CalcData.Products[index].ToPayCheck) {// || this.account.CalcData.Products[index].IsUserPay) {
                            if (this.account.CalcData.Products[index].IsFine && this.account.CalcData.Products[index].ToPayProd > 0) {
                                sum += this.account.CalcData.Products[index].ToPayProd;
                            }
                            if (!this.account.CalcData.Products[index].IsFine) {
                                sum += this.account.CalcData.Products[index].ToPayProd;
                            }
                        }
                    }
                    this.sumPay = Math.round(sum * 100) / 100;
                }
                else {
                    this.sumPay = Math.round(this.account.ToPay * 100) / 100;
                }
                if (this.sumPay < 0) this.sumPay = 0;
            },
            imageUrl: function (ps) {
                ps = ps.substring(0, 2);
                if (ps === 'Сп') return '';
                if (ps === 'Га') return '/images/pay-types/gasprombank-icon.png';
                if (ps === 'Сб') return '/images/pay-types/sberbank-icon.png';
                ps = ps.substring(0, 1);
                if (ps === '2') return "/images/pay-types/mir.png";
                else if (ps === '4') return "/images/pay-types/visa.png"
                else if (ps === '5') return "/images/pay-types/mastercard.png";
                else if (ps === '6') return "/images/UnionPay.png";
                return "/images/other.png";
            }
        },
        watch: {
            agree: function (newCheck) {
                this.$emit('updateAgree', newCheck);
            }
        },
        mounted() {
            if (this.account.BspId.toUpperCase() === 'KYZL') this.merchCode = "KZ";
            for (var index in this.cards) {
                var year = Number('20' + this.cards[index].ExpDate.substring(0, 2));
                var mounth = Number(this.cards[index].ExpDate.substring(2, 4));
                var color = 'green';
                if (new Date() > new Date(year, mounth, 0)) color = 'red';
                if (new Date() < new Date(year, mounth - 6, 1)) color = 'inherit';
                var expDate = this.cards[index].ExpDate.substring(2) + '/' + this.cards[index].ExpDate.substring(0, 2);
                var img = this.imageUrl(this.cards[index].MaskName);
                if ((this.cards[index].MerchCode === "SB") && (this.account.isSber)) {
                    let opt = {
                        CardId: this.cards[index].CardId,
                        MaskName: this.cards[index].MaskName.replaceAll('X', 'x'),
                        ExpDate: expDate,
                        image: img,
                        color: color
                    }
                    this.optionsSber.push(opt);
                }
                if (this.cards[index].MerchCode === this.merchCode) {
                    let opt = {
                        // IsDefault: this.cards[index].IsDefault,
                        CardId: this.cards[index].CardId,
                        MaskName: this.cards[index].MaskName,
                        ExpDate: expDate,
                        image: img,
                        color: color
                    };
                    this.options.push(opt);
                }
            }

            /* Карта по умолчанию не назначается.
            // Карта по умолчанию первая.
            this.options.sort(function (a, b) {
                if (a.IsDefault === true)
                    return -1;
                return 1;
            }); */
            this.agree = this.checkAgreement;

            var self = this;
            this.$nextTick(function () {
                self.calc();
                $('#cards-list_' + self.account.PersonAccountId).selectpicker('refresh');
            });
        }
    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-pay.vue